import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { sendRequestFeedbackAction } from "../../../app/appActions";
import { isClientAndroid, isClientIOS } from "../../../components/ClientInfo/ClientInfo";

function useSkipFeedback(isPopup: boolean) {
    const dispatch = useDispatch();

    const handleSkipFeedback = useCallback(() => {
        dispatch(sendRequestFeedbackAction({
            comment: 'skip',
            device: isClientIOS ? 'ios' : isClientAndroid ? 'android' : 'web',
            rating: 0,
            source: isPopup ? 'popup' : 'page',
        }));
    }, [dispatch, isPopup]);

    return handleSkipFeedback;
}

export default useSkipFeedback;